import { z } from "zod";

/**
 * The upload id one drop produced, which is also every one of its files' `directory`.
 *
 * A plain string rather than a uuid: the id comes from the storage path the upload endpoint built,
 * and the route hands it straight to an equality comparison.
 */
export const getFileBatchParamSchema = z.object({
	batchId: z.string().min(1),
});

export type GetFileBatchParamSchema = z.infer<typeof getFileBatchParamSchema>;
